<div class="ChooseFrequencyDialog">
  <form [formGroup]="inputForm">
    <mat-radio-group
      class="ChooseFrequencyDialog-radio"
      aria-label="Select an frequency"
      formControlName="frequency">
      <mat-radio-button class="ChooseFrequencyDialog-radio-button" value="1"
        >Every month</mat-radio-button
      >
      <mat-radio-button class="ChooseFrequencyDialog-radio-button" value="2"
        >Every 2 months</mat-radio-button
      >
      <mat-radio-button class="ChooseFrequencyDialog-radio-button" value="3"
        >Every 3 months</mat-radio-button
      >
      <mat-radio-button class="ChooseFrequencyDialog-radio-button" value="6"
        >Every 6 months</mat-radio-button
      >
      <mat-radio-button class="ChooseFrequencyDialog-radio-button" value="9"
        >Every 9 months</mat-radio-button
      >
      <mat-radio-button class="ChooseFrequencyDialog-radio-button" value="12"
        >Every 12 months</mat-radio-button
      >
    </mat-radio-group>
  </form>
</div>
